import { useEnvironment, useGlobal } from "../../../core/Global";
import Icon from "../../base/Icon";
import ThemeToggle from "../../base/ThemeToggle";
import "./SignUpLayout.css";


function SignUpLayout(props: { children: any }) {

	const env = useEnvironment();
	const [globalState] = useGlobal();

	const stepClass = (st: number) => {
		var cls = " d-flex align-items-center flex-row mb-10";
		var step = globalState.signupStep ?? 1;
		if (step == st) cls += " current";
		if (step > st) cls += " completed";
		if (step < st) cls += " pending";
		return cls;
	}

	return (
		<div className="d-flex flex-column flex-lg-row flex-column-fluid stepper stepper-pills stepper-column signup-shell" id="kt_create_account_stepper">

			<ThemeToggle />

			<div className="d-flex flex-column flex-lg-row-auto bg-lighten shadow-sm signup-aside-col">
				<div className="d-flex flex-column signup-aside-panel">
					<div className="d-flex flex-row-fluid flex-column align-items-center signup-aside-content">
						<a className="mb-10">
							<img alt={env.siteTitle} src={`/assets/brands/${env.brand}/logo.png`} className="h-50px" />
						</a>

						{
							(globalState.signupStep ?? 1) <= 6 &&
							<div className="stepper-nav">

								<div className={"stepper-item" + stepClass(1)} data-kt-stepper-element="nav">

									<div className="stepper-line w-40px"></div>
									<div className="stepper-icon w-40px h-40px">
										<i className="stepper-check fas fa-check"></i>
										<span className="stepper-number">1</span>
									</div>
									<div className="stepper-label">
										<h3 className="stepper-title">Personal Information</h3>
										<div className="stepper-desc fw-bold">You must verify your email address!</div>
									</div>
								</div>
								<div className={"stepper-item" + stepClass(2)} data-kt-stepper-element="nav">

									<div className="stepper-line w-40px"></div>
									<div className="stepper-icon w-40px h-40px">
										<i className="stepper-check fas fa-check"></i>
										<span className="stepper-number">2</span>
									</div>
									<div className="stepper-label">
										<h3 className="stepper-title">Sign-In Options</h3>
										<div className="stepper-desc fw-bold">Setup your own username and password</div>
									</div>
								</div>
								<div className={"stepper-item" + stepClass(3)} data-kt-stepper-element="nav">
									<div className="stepper-line w-40px"></div>
									<div className="stepper-icon w-40px h-40px">
										<i className="stepper-check fas fa-check"></i>
										<span className="stepper-number">3</span>
									</div>
									<div className="stepper-label">
										<h3 className="stepper-title">Add Business</h3>
										<div className="stepper-desc fw-bold">Add your company information</div>
									</div>
								</div>

								{/* Choosing a plan replaced the old "Payment Method" and "Invoice" pair:
								    what is owed cannot be worked out before a plan is picked, and Free
								    is owed nothing at all. The internal step numbers behind the last
								    two items are still 4 and 6 — step 5 no longer exists in the journey
								    — so only the numbers the customer reads were renumbered. */}
								<div className={"stepper-item" + stepClass(4)} data-kt-stepper-element="nav">
									<div className="stepper-line w-40px"></div>
									<div className="stepper-icon w-40px h-40px">
										<i className="stepper-check fas fa-check"></i>
										<span className="stepper-number">4</span>
									</div>
									<div className="stepper-label">
										<h3 className="stepper-title">Choose Plan</h3>
										<div className="stepper-desc fw-bold">Pick the plan that fits your operation</div>
									</div>
								</div>

								<div className={"stepper-item" + stepClass(6)} data-kt-stepper-element="nav">
									<div className="stepper-line w-40px"></div>
									<div className="stepper-icon w-40px h-40px">
										<i className="stepper-check fas fa-check"></i>
										<span className="stepper-number">5</span>
									</div>
									<div className="stepper-label">
										<h3 className="stepper-title">Finalize</h3>
										<div className="stepper-desc fw-bold">Go to your dashboard</div>
									</div>
								</div>

							</div>
						}

						{
							(globalState.signupStep ?? 1) > 6 &&
							<div className="stepper-nav">

								{/* Setting the account up starts with the CRM's own base data — the kinds
								    of work this business does — because everything after it hangs off
								    that. Inserting it at 7 moved each of the others up by one. */}
								<div className={"stepper-item" + stepClass(7)} data-kt-stepper-element="nav">

									<div className="stepper-line w-40px"></div>
									<div className="stepper-icon w-40px h-40px">
										<i className="stepper-check fas fa-check"></i>
										<span className="stepper-number">
											<Icon icon="briefcase" type="solid" size={18} />
										</span>
									</div>
									<div className="stepper-label">
										<h3 className="stepper-title">Job Types</h3>
										<div className="stepper-desc fw-bold">What kind of work do you do?</div>
									</div>
								</div>

								<div className={"stepper-item" + stepClass(8)} data-kt-stepper-element="nav">

									<div className="stepper-line w-40px"></div>
									<div className="stepper-icon w-40px h-40px">
										<i className="stepper-check fas fa-check"></i>
										<span className="stepper-number">
											<Icon icon="bullhorn" type="solid" size={18} />
										</span>
									</div>
									<div className="stepper-label">
										<h3 className="stepper-title">Job Sources</h3>
										<div className="stepper-desc fw-bold">Where does your work come from?</div>
									</div>
								</div>

								{/* The money the account runs on, and the gate in front of the two number
								    steps: a number costs money every month and its calls are paid for by the
								    minute, so an account with an empty wallet is not given one here. */}
								<div className={"stepper-item" + stepClass(9)} data-kt-stepper-element="nav">

									<div className="stepper-line w-40px"></div>
									<div className="stepper-icon w-40px h-40px">
										<i className="stepper-check fas fa-check"></i>
										<span className="stepper-number">
											<Icon icon="wallet" type="solid" size={18} />
										</span>
									</div>
									<div className="stepper-label">
										<h3 className="stepper-title">Charge Wallet</h3>
										<div className="stepper-desc fw-bold">Add credit to get started</div>
									</div>
								</div>

								<div className={"stepper-item" + stepClass(10)} data-kt-stepper-element="nav">

									<div className="stepper-line w-40px"></div>
									<div className="stepper-icon w-40px h-40px">
										<i className="stepper-check fas fa-check"></i>
										<span className="stepper-number">
											<Icon icon="phone" type="solid" size={18} />
										</span>
									</div>
									<div className="stepper-label">
										<h3 className="stepper-title">Phone Number</h3>
										<div className="stepper-desc fw-bold">The number customers call</div>
									</div>
								</div>

								{/* Where the chosen number's calls go. Finishing it buys the number and
								    sets everything up, then opens the console. */}
								<div className={"stepper-item" + stepClass(11)} data-kt-stepper-element="nav">

									<div className="stepper-line w-40px"></div>
									<div className="stepper-icon w-40px h-40px">
										<i className="stepper-check fas fa-check"></i>
										<span className="stepper-number">
											<Icon icon="phone-office" type="solid" size={18} />
										</span>
									</div>
									<div className="stepper-label">
										<h3 className="stepper-title">Number Setup</h3>
										<div className="stepper-desc fw-bold">Where its calls go</div>
									</div>
								</div>

								<div className={"stepper-item" + stepClass(12)} data-kt-stepper-element="nav">

									<div className="stepper-line w-40px"></div>
									<div className="stepper-icon w-40px h-40px">
										<i className="stepper-check fas fa-check"></i>
										<span className="stepper-number">
											<Icon icon="check" type="solid" size={18} />
										</span>
									</div>
									<div className="stepper-label">
										<h3 className="stepper-title">Done</h3>
										<div className="stepper-desc fw-bold">Go to your console!</div>
									</div>
								</div>

							</div>
						}

					</div>
					<div className="d-none d-lg-block bgi-no-repeat bgi-position-x-center bgi-size-contain bgi-position-y-bottom signup-aside-art"
						style={{ backgroundImage: "url(/assets/media/illustrations/sketchy-1/16.png)" }}></div>
				</div>
			</div>

			<div className="d-flex flex-column flex-lg-row-fluid signup-main">

				{/* The only part of the page that scrolls. The wizard beside it and the action bar
				    below it are both out of this box, so neither of them can be scrolled away. */}
				<div className="d-flex flex-column flex-column-fluid signup-content">
					{props.children}
				</div>

			</div>
		</div>
	)
}

export default SignUpLayout;